import { createGlobalStyle } from 'styled-components';
import { color, font } from '../variables';

const GlobalStyle = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/ 
    v2.0 | 20110126
    License: none (public domain)
  */

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font: inherit;
    font-size: 100%;
    vertical-align: baseline;
    border: 0;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* -------------------------------------- */
  /* ------------ Custom Styles ----------- */
  /* -------------------------------------- */

  html, body, #root {
    height: 100%;
  }

  body {
    color: ${color.black};
    font-size: 16px;
    font-family: ${font.montserrat};
  }

  a {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
  }

  p, li {
    line-height: 1.5;
  }

  a, span, p, li {
    font-size: .875em;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: ${font.fontWeightBold};
  }

  h1 {
    font-size: 2em;
  }

  h2 {
    font-size: 1.5em;
  }

  h3 {
    font-size: 1.25em;
  }

  h4 {
    font-size: 1em;
  }

  h5 {
    font-size: .875em;
  }

  h6 {
    font-size: .75em;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  input {
    font-family: ${font.montserrat};
  }
`;

export default GlobalStyle;
